// ProductCard.js
import {
  defineComponent,
  computed,
  toRefs,
  inject,
} from "/Scripts/vue.esm-browser.js";
import { transformPresentImageUrl } from "/Scripts/tools.js";

const html = String.raw;
export default defineComponent({
  name: "ProductCard",
  props: {
    item: {
      type: Object,
      required: true,
    },
    isAllProduct: {
      type: Boolean,
      default: false,
    },
    isSearch: {
      type: Boolean,
      default: false,
    },
    groupShowType: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
    },
  },
  emits: [],
  setup(props, { emit }) {
    const { item } = toRefs(props);
    //const groupShowType = inject("groupShowType");
    const isCompareSelected = inject("isCompareSelected", () => false);
    const toggleCompare = inject("toggleCompare", () => {});
    const groupMinPrice = computed(() => {
      // 使用reduce找出價格最低的group
      return item.value.groups.reduce(
        (minGroup, currentGroup) => {
          // 如果當前group的price比目前找到的最低價更低，則更新minGroup
          if (currentGroup.price < minGroup.price) {
            return {
              price: currentGroup.price,
              sitePrice: currentGroup.sitePrice,
            };
          }
          // 否則保持原來的minGroup
          return minGroup;
        },
        {
          price: item.value.groups[0].price,
          sitePrice: item.value.groups[0].sitePrice,
        },
      );
    });

    const waitingGroups = computed(() => {
      // 如果沒有groups或groups為空陣列，返回空物件
      if (!item.value.groups || item.value.groups.length === 0) {
        return {};
      }
      return item.value.groups.filter((group) => group.remainSeat === 0);
    });
    const earliestGroup = computed(() => {
      // 如果沒有groups或groups為空陣列，返回空物件
      if (!item.value.groups || item.value.groups.length === 0) {
        return {};
      }

      // 使用reduce找出leaveDate最小的group
      return item.value.groups.reduce((earliest, current) => {
        // 將日期字串轉換成Date物件進行比較
        const earliestDate = new Date(earliest.leaveDate.replace(/\//g, "-"));
        const currentDate = new Date(current.leaveDate.replace(/\//g, "-"));
        // 返回日期較早的group
        return currentDate < earliestDate ? current : earliest;
      });
    });
    const goProduct = (groupCode, event) => {
      // 阻止事件冒泡，避免觸發其他點擊事件
      event.stopPropagation();
      event.preventDefault();
      window.open(`/tour/${groupCode}`, "_blank");
    };
    const getTargetUrl = (groupCode) => {
      let url = "null";
      if (groupCode) {
        url = `/tour/${groupCode}`;
      }
      return url; // 返回目標URL
    };

    const getEnsureDateHtml = (groups) => {
      const groupedDates = {};

      // 先按照 leaveDate 排序，確保跨年時的順序正確
      groups
        .filter((g) => g.leaveDate) // 過濾掉空的
        .sort((a, b) => {
          const dateA = new Date(a.leaveDate.replace(/\//g, "-"));
          const dateB = new Date(b.leaveDate.replace(/\//g, "-"));
          return dateA - dateB;
        })
        .forEach((item) => {
          const [year, month, day] = item.leaveDate.split("/");
          const monthNum = parseInt(month, 10);
          const dayNum = parseInt(day, 10);

          const key = `${year}-${monthNum}`;
          if (!groupedDates[key]) {
            groupedDates[key] = new Set(); // 用 Set 來避免重複
          }
          groupedDates[key].add(dayNum);
        });

      const html = Object.keys(groupedDates)
        .map((date) => {
          const [, month] = date.split("-");
          const days = Array.from(groupedDates[date])
            .sort((a, b) => a - b)
            .join(".");
          return `${month}月${days}`;
        })
        .join("、");

      return html;
    };
    const handleClick = (event, groupCode) => {
      if (!groupCode) {
        event.preventDefault();
      }
    };

    const { date, weekday, time } = (() => {
      // Chinese month names
      const chineseMonths = [
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月",
      ];

      // Chinese weekday names
      const chineseWeekdays = ["日", "一", "二", "三", "四", "五", "六"];

      // Parse the date string
      const date = new Date(props.item.openDate);

      // Extract components
      const month = chineseMonths[date.getMonth()];
      const day = date.getDate() + "日";
      const weekday = chineseWeekdays[date.getDay()];
      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");

      // Format the result
      return {
        date: `${month}${day}`,
        weekday: weekday,
        time: `${hours}:${minutes}`,
      };
    })();
    // 獲取今天的日期
    const today = new Date();
    today.setHours(0, 0, 0, 0); // 設定為當天的 00:00:00
    // 使用 lodash 判斷是否所有 orderDeadline 都小於今天
    const allDeadlinesPassed = _.every(item.value.groups, (item) => {
      const deadlineDate = new Date(item.orderDeadline);
      deadlineDate.setHours(0, 0, 0, 0);
      return deadlineDate < today;
    });
    // 根據需求：如果所有 orderDeadline 都小於今天，回傳 false
    const isAvailable = !allDeadlinesPassed;
    // const remainSeat = _.sumBy(item.value.groups, (group) => group.remainSeat);
    const remainSeat = _.some(
      item.value.groups,
      (group) => group.remainSeat === 0,
    )
      ? 0
      : _.sumBy(item.value.groups, (group) => group.remainSeat);
    const discountInfo = computed(() => {
      const groups = item.value?.groups ?? [];
      if (groups.length === 0) return [];

      // 依 discount 分組，存 { leaveDate, groupCode }
      const map = new Map();
      for (const g of groups) {
        if (!g?.discount || !g?.leaveDate) continue;
        const arr = map.get(g.discount) ?? [];
        arr.push({ leaveDate: g.leaveDate, groupCode: g.groupCode });
        map.set(g.discount, arr);
      }

      const parseDate = (s) => {
        const [y, m, d] = s.split("/").map(Number);
        return new Date(y, m - 1, d); // 本地時區
      };

      const result = [];
      for (const [discount, items] of map.entries()) {
        // 以 leaveDate 去重（同日多筆只保留遇到的第一筆）
        const seen = new Set();
        const uniqAll = [];
        for (const it of items) {
          if (seen.has(it.leaveDate)) continue;
          seen.add(it.leaveDate);
          uniqAll.push({
            raw: it.leaveDate,
            date: parseDate(it.leaveDate),
            groupCode: it.groupCode,
          });
        }

        // 日期由早到晚排序
        uniqAll.sort((a, b) => a.date - b.date);

        const hasMore = uniqAll.length > 3;
        const top3 = uniqAll.slice(0, 3);

        // 依月份分群並格式化
        const monthGroups = [];
        let currentMonth = null;
        let currentList = [];
        for (const { date } of top3) {
          const month = date.getMonth() + 1;
          const day = date.getDate();
          if (month !== currentMonth) {
            if (currentList.length > 0) monthGroups.push(currentList);
            currentList = [{ month, day }];
            currentMonth = month;
          } else {
            currentList.push({ month, day });
          }
        }
        if (currentList.length > 0) monthGroups.push(currentList);

        let leaveDateStr = monthGroups
          .map((g) => `${g[0].month}月` + g.map((x) => x.day).join("."))
          .join("、");
        if (hasMore) leaveDateStr += "…";

        // 最早日期的 groupCode
        const firstGroupCode = uniqAll[0]?.groupCode ?? null;

        result.push({ discount, leaveDateStr, firstGroupCode });
      }

      return result;
    });

    const getImageUrl = (picture, fileName) => {
      picture = picture
        ? transformPresentImageUrl(picture, { targetHeight: 250 })
        : "";

      if (fileName && picture) {
        picture = `${picture}/.${fileName}`;
      }
      return picture;
    };
    return {
      groupMinPrice,
      group: earliestGroup.value || {},
      earliestGroup,
      remainSeat: isAvailable ? remainSeat : -1,
      goProduct,
      getTargetUrl,
      handleClick,
      getEnsureDateHtml,
      date,
      weekday,
      time,
      discountInfo,
      waitingGroups,
      getImageUrl,
      isCompareSelected,
      toggleCompare,
    };
  },
  template: html`
    <a
      :href="getTargetUrl(earliestGroup?.groupCode || item.mainGroupCode)"
      target="_blank"
      class="product-card"
      :data-main-group-code="item.mainGroupCode"
      :class="{'waitList':remainSeat===0,'soldOut':remainSeat===-1}"
      @click="handleClick(earliestGroup?.groupCode || item.mainGroupCode)"
    >
      <div class="soldOutTag">
        <img
          v-if="remainSeat===0"
          loading="lazy"
          src="/action/theme/clearanceSale/V2/images/waitListTag.png"
          alt=""
        />
        <img
          v-else-if="remainSeat===-1"
          loading="lazy"
          src="/Content/img/Promotions/keyword/soldoutTag.png"
          alt=""
        />
      </div>
      <div class="product_img">
        <div class="PdTag">{{item.departure}}出發</div>
        <div
          class="product_button"
          v-if="item.openDate && item.openDate !== 'null'"
        >
          <div>
            {{date}}
            <span class="product_week">{{weekday}}</span>
            {{time}}
            <span class="product_h3">準時搶購</span>
          </div>
        </div>
        <picture>
          <source
            :srcset="getImageUrl(item.picture,'avif')"
            media="(min-width: 992px)"
          />
          <source
            :srcset="getImageUrl(item.picture)"
            media="(min-width: 992px)"
          />
          <img
            loading="lazy"
            src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="
            :alt="item.groupName"
          />
        </picture>
      </div>
      <div class="product_Content">
        <div class="product_title">{{item.groupName}}</div>
        <ul class="product_label" v-if="item.hashTagList.length">
          <li v-for="hashTag in item.hashTagList">{{hashTag}}</li>
        </ul>
        <div class="card_discount_wrap">
          <!--<div class="card_discount" v-if="item.discount || isLoading">
                        <template v-if="item.discount">優惠方案：{{item.discount}}</template>
                    </div>-->
          <div class="card_discount" v-for="discount in discountInfo">
            <a :href="'/tour/'+discount.firstGroupCode" target="_blank">
              <span class="card_discount-main">
                優惠方案：{{discount.discount}}
              </span>

              <span class="card_discount-note">
                *優惠方案之適用日期：{{discount.leaveDateStr}}
              </span>
            </a>
          </div>
          <div class="card_date">
            <template v-if="!isLoading">
              限定出發：{{ getEnsureDateHtml(item.groups) }}
            </template>
          </div>

          <div class="card_waitingDate" v-if="waitingGroups.length > 0">
            <template v-if="!isLoading">
              候補日期：{{ getEnsureDateHtml(waitingGroups) }}
            </template>
          </div>
        </div>

        <div class="product_price_wrap">
          <div
            :id="item.mainGroupCode"
            class="favro fav-btn"
            :class="isCompareSelected(item.mainGroupCode) ? 'compare_1' : 'compare_0'"
            @click="toggleCompare(item.mainGroupCode, $event)"
          >
            <svg
              class="icon-favro"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="18"
              viewBox="0 0 20 18"
              fill="none"
            >
              <path
                d="M3.52051 1.25488C4.85621 0.699639 6.1397 0.862288 7.35449 1.69141V1.69238C7.84078 2.02699 8.25402 2.4377 8.60645 2.91016L8.75391 3.11719H8.75488C8.78234 3.15714 8.81414 3.19916 8.83008 3.2207L8.86426 3.26953C9.11064 3.70513 9.5161 3.99217 9.99414 3.99121C10.4704 3.99006 10.8783 3.7028 11.1318 3.28223L11.1328 3.2832C11.2653 3.06686 11.4238 2.85592 11.5996 2.65039L11.7812 2.44727V2.44629C12.3977 1.77302 13.0983 1.28186 13.9434 1.07715L14.1143 1.04004H14.1172C15.5253 0.762647 16.7365 1.12439 17.7822 2.03223L17.9883 2.2207H17.9893C18.9529 3.14203 19.4865 4.42292 19.498 5.73633L19.4951 5.74316L19.4941 5.8623C19.4803 7.49979 18.9238 8.97227 18.0078 10.3613L17.8203 10.6377C16.8933 11.965 15.7399 13.0947 14.4521 14.1191L13.8926 14.5518C12.664 15.4748 11.357 16.285 9.99805 17.0361C8.38709 16.1403 6.84614 15.1686 5.4375 14.0312L4.8291 13.5225C3.50646 12.37 2.35878 11.1093 1.54102 9.61816L1.38184 9.31641C0.793702 8.14759 0.448014 6.96669 0.505859 5.73633L0.523438 5.49023V5.4873C0.69258 3.5092 1.62758 2.04289 3.51953 1.25391L3.52051 1.25488Z"
                stroke="#736357"
              ></path>
            </svg>
          </div>
          <div class="price_2">{{groupMinPrice.price?.toLocaleString()}}</div>
          <div class="price">{{groupMinPrice.sitePrice?.toLocaleString()}}</div>
        </div>
      </div>
    </a>
  `,
  methods: {
    getStatusClass(status) {
      return `type${status}`;
    },
    removeParenthesesContent(str) {
      return str.replace(/（.*?）/g, "");
    },
  },
});
